// @ts-ignore
import ReactDOM from 'react-dom'
import { merge, keyBy, values } from 'lodash'
import App from './App'
import {
  FilterSettings,
  TagsSettings,
  PropertiesSettings,
  SortSettings,
  PriceProps
} from '../types/Main'
import { defaultOptions } from './utils/defaultOptions'

export default class Main implements FilterSettings {
  element: HTMLElement | null;
  mode: 'horizontal' | 'vertical' | 'drawer' | 'balloon';
  isOpen: boolean;
  sideDrawer: 'left' | 'right';
  hasInputSearch: boolean;
  hasSort: boolean;
  filterOnClick: boolean;
  resetMode: 'all' | 'each' | 'none';
  tags: Array<TagsSettings>;
  properties: Array<PropertiesSettings>;
  sort: SortSettings;
  price?: Array<number>;
  priceProps?: PriceProps;

  constructor (options: FilterSettings & { startOpen: boolean }) {
    this.element = null
    this.mode = options.mode || defaultOptions.mode
    this.isOpen = options.isOpen || defaultOptions.isOpen
    this.sideDrawer = options.sideDrawer || defaultOptions.sideDrawer
    this.hasInputSearch = options.hasInputSearch || defaultOptions.hasInputSearch
    this.hasSort = options.hasSort || defaultOptions.hasSort
    this.filterOnClick = options.filterOnClick || defaultOptions.filterOnClick
    this.resetMode = options.resetMode || defaultOptions.resetMode
    this.tags = options.tags || defaultOptions.tags
    this.properties = options.properties || defaultOptions.properties
    this.sort = options.sort || defaultOptions.sort
    this.price = options.price
    this.priceProps = options.priceProps || defaultOptions.priceProps
    this.rerender = this.rerender.bind(this)
    this.open = this.open.bind(this)
    this.close = this.close.bind(this)
    this.toggle = this.toggle.bind(this)
  }

  open () {
    this.rerender(true)
  }

  close () {
    this.rerender(false)
  }

  toggle () {
    this.rerender(!this.isOpen)
  }

  rerender (open?: boolean) {
    this.isOpen = open === undefined ? this.isOpen : open
    this.properties.map(property => {
      return values(
        merge(
          keyBy(property.options, 'value'),
          keyBy(property.patterns, 'value')
        )
      )
    })

    const props = {
      mode: this.mode,
      isOpen: this.isOpen,
      sideDrawer: this.sideDrawer,
      hasInputSearch: this.hasInputSearch,
      hasSort: this.hasSort,
      filterOnClick: this.filterOnClick,
      resetMode: this.resetMode,
      tags: this.tags,
      properties: this.properties,
      sort: this.sort,
      price: this.price,
      priceProps: this.priceProps,
      closeDrawer: this.close
    }

    ReactDOM.render(<App {...props} />, this.element)

    if (module.hot) {
      module.hot.accept('./App', () => {
        ReactDOM.render(<App {...props} />, this.element)
      })
    }
  }

  render (element: HTMLElement): void {
    this.element = element
    this.rerender()
  }
}
